import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Box,
  IconButton,
  Typography,
  TableFooter,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Add } from "@mui/icons-material";
import {
  validateNumberInput,
  validatePercentageInput,
} from "../../../../utils/validateFields";
import InputField from "../../../../Components/Masters/InputField";
import CircleIcon from "@mui/icons-material/Circle";
import style from "../../../../styles/gri/general.module.css";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";

const DynamicRegionTable = ({
  inputData,
  tables,
  setTables,
  errors,
  setErrors,
  defaultSegments,
  parameter,
  total,
  setTotal,
  data,
  disabled,
  hide,
}) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [fieldToRemove, setFieldToRemove] = React.useState({
    fieldName: null,
    tableIndex: null,
  });
  const [isAdded, setIsAdded] = useState({});
  const [tableIndex, setTableIndex] = useState("");
  useEffect(() => {
    if (data?.[inputData?.fieldName]?.length) {
      setTables(
        data?.[inputData?.fieldName]?.map((el) => ({
          region: el?.region || "",
          table: [el?.male || [], el?.female || []],
          maleTotal: el?.maleTotal,
          femaleTotal: el?.femaleTotal,
        }))
      );
    } else {
      setTables([
        {
          region: "",
          table: [
            defaultSegments.map((category) => ({
              [parameter]: category,
            })),
            defaultSegments.map((category) => ({
              [parameter]: category,
            })),
          ],
          maleTotal: {},
          femaleTotal: {},
        },
      ]);
    }
    checkIsAdded();
  }, [data]);

  const handleAddTable = () => {
    setTables([
      ...tables,
      {
        region: "",
        table: [
          defaultSegments.map((category) => ({
            [parameter]: category,
          })),
          defaultSegments.map((category) => ({
            [parameter]: category,
          })),
        ],
      },
    ]);
    setIsAdded((prev) => ({
      ...prev,
      [inputData?.fieldName]: true,
    }));
  };

  const handleInputChange = (
    tableIndex,
    rowIndex,
    fieldName,
    value,
    index,
    type
  ) => {
    // Validation for percentage and number fields
    if (type === "percentage" && !validatePercentageInput(value)) return;
    if (type === "number" && !validateNumberInput(value)) return;

    const updatedTables = [...tables];

    updatedTables[tableIndex].table[index][rowIndex][fieldName] = value;

    const newTotals = updatedTables[tableIndex].table[index].reduce(
      (acc, row) => {
        Object.keys(row).forEach((fieldName) => {
          if (fieldName === "ageGroup") return;

          acc[fieldName] = (acc[fieldName] || 0) + Number(row[fieldName] || 0);
        });
        return acc;
      },
      {}
    );

    updatedTables[tableIndex][index === 0 ? "maleTotal" : "femaleTotal"] =
      newTotals;

    setTables(updatedTables);
    checkIsAdded();
  };

  const handleDeleteTable = (region, indexToDelete) => {
    setTableIndex(indexToDelete);
    const hasEntries = region?.table?.some((table) =>
      table?.some((el) =>
        Object.values(
          Object.fromEntries(
            Object.entries(el).filter(
              ([key]) => key !== "ageGroup" && key !== "_id"
            )
          )
        ).some(
          (val) =>
            val !== undefined &&
            val !== "" &&
            val !== null &&
            !(Array.isArray(val) && val.length === 0)
        )
      )
    );
    if (hasEntries) {
      setOpenDialog(true);
      setTableIndex(indexToDelete);
    } else {
      const updatedTables = tables
        .filter((_, index) => index !== indexToDelete)
        .map((table, index) => ({
          ...table,
          region: `Region ${index + 1}`,
        }));
      setTables(updatedTables);
    }
    setIsAdded((prev) => ({
      ...prev,
      [inputData?.fieldName]: false,
    }));
  };

  const cancelRemoveTable = () => {
    setOpenDialog(false);
    setTableIndex("");
  };

  const confirmRemoveTable = () => {
    const updatedTables = tables
      .filter((_, index) => index !== tableIndex)
      .map((table, index) => ({
        ...table,
        region: `Region ${index + 1}`,
      }));
    setTables(updatedTables);
    setTableIndex("");
    setOpenDialog(false);
    setIsAdded((prev) => ({
      ...prev,
      [inputData?.fieldName]: false,
    }));
  };

  const checkIsAdded = () => {
    const allTables = tables[tables?.length - 1]?.table || [];
    const region = tables[tables?.length - 1]?.region || "";

    const results = allTables.map((table) =>
      table.map((el) => {
        const filteredValues = Object.values(
          Object.fromEntries(
            Object.entries(el).filter(
              ([key]) => key !== "ageGroup" && key !== "_id"
            )
          )
        );

        const filledValues = filteredValues.filter(
          (val) => val !== undefined && val !== "" && val !== null
        );

        return filledValues.length === 2;
      })
    );

    const allFilledCorrectly = results.flat().every(Boolean);
    console.log(region, tables[tables?.length - 1], "reg1");
    const hasError = region === "" || !allFilledCorrectly;

    setIsAdded((prev) => ({
      ...prev,
      [inputData?.fieldName]: hasError,
    }));
  };

  return (
    <Box>
      <DeleteRowDialog
        {...{
          openDialog,
          cancelRemoveRow: cancelRemoveTable,
          confirmRemoveRow: confirmRemoveTable,
        }}
      />
      <Box
        sx={{ fontWeight: "bold", fontSize: "16px", display: "flex", gap: 1 }}
      >
        {inputData?.letter && (
          <p className={style.ques_heading}>{inputData.letter}</p>
        )}
        <p className={style.ques_heading}>{inputData.title}</p>
      </Box>
      {tables?.map((table, tableIndex) => (
        <Box key={tableIndex} sx={{ mb: 4, ml: 2 }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography
              sx={{
                padding: "3px",
                fontWeight: 500,
                fontSize: "15px",
                mt: 1.5,
                lineHeight: "22px",
                fontFamily: "inter",
                width: "5rem",
              }}
            >
              {`Region  ${tableIndex + 1}`} :
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // mb: 2,
                width: "90%",
              }}
            >
              <InputField
                placeholder={`Region ${tableIndex + 1}`}
                fullWidth
                sx={{ width: "30%" }}
                value={table?.region}
                handleChange={(e) => {
                  const updatedTables = [...tables];
                  updatedTables[tableIndex].region = e.target.value;
                  setTables(updatedTables);
                  checkIsAdded();
                }}
                disabled={disabled}
              />

              {tables.length > 1 && (
                <IconButton
                  color="error"
                  onClick={() => handleDeleteTable(table, tableIndex)}
                  sx={{ width: "5%" }}
                  disabled={disabled}
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
          </Box>

          {table?.table?.map((category, index) => (
            <Box>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  mt: "1rem",
                  color: "#EB7E0E",
                  fontSize: "16px",
                }}
              >
                <CircleIcon sx={{ fontSize: "10px" }} />{" "}
                {index === 0 ? "Male" : "Female"}
              </Typography>
              <TableContainer
                component={Paper}
                sx={{
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  borderRadius: "10px",
                  mt: 1,
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1C486B" }}>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: 600,
                          borderRight: "1px solid #D3D3D3",
                        }}
                      >
                        S.No.
                      </TableCell>
                      {inputData?.fields.map((field, index) => (
                        <TableCell
                          key={index}
                          sx={{
                            color: "white",
                            fontWeight: 600,
                            borderRight: "1px solid #D3D3D3",
                          }}
                        >
                          {field.title}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {category?.map((row, rowIndex) => {
                      return (
                        <TableRow key={rowIndex}>
                          <TableCell
                            sx={{
                              borderRight: "1px solid #D3D3D3",
                              // padding: "6px 12px",
                              lineHeight: "1.2",
                              textAlign: "center",
                            }}
                          >
                            {rowIndex + 1}.
                          </TableCell>

                          {inputData?.fields?.map((field, fieldIndex) => (
                            <TableCell
                              key={fieldIndex}
                              sx={{
                                borderRight: "1px solid #D3D3D3",
                                backgroundColor:
                                  field.fieldName === "percentage"
                                    ? "#EFEFEF"
                                    : "",
                                padding: "6px 12px",
                                // lineHeight: "1.2",
                                color:
                                  field.fieldName === parameter && "#1C486B",
                              }}
                            >
                              {field.fieldName === parameter &&
                              rowIndex < defaultSegments?.length ? (
                                <p
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    lineHeight: "16.94px",
                                    fontFamily: "inter",
                                    marginTop: "1rem",
                                  }}
                                >
                                  {row[field.fieldName]}
                                </p>
                              ) : (
                                <TextField
                                  value={row[field.fieldName] || ""}
                                  disabled={disabled}
                                  onChange={(e) =>
                                    handleInputChange(
                                      tableIndex,
                                      rowIndex,
                                      field.fieldName,
                                      e.target.value,
                                      index,
                                      field.type
                                    )
                                  }
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: 0,
                                      "& fieldset": {
                                        border: "none",
                                      },
                                    },
                                  }}
                                  placeholder={field.placeholder}
                                  fullWidth
                                />
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      );
                    })}
                    <TableRow sx={{ ml: 1, backgroundColor: "#D8D8D8" }}>
                      <TableCell></TableCell>
                      {inputData?.fields.map((el) => {
                        let displayValue = "";

                        if (el?.fieldName === "ageGroup") {
                          if (index === 0) {
                            displayValue = "Total Male";
                          } else {
                            displayValue = "Total Female";
                          }
                        } else if (
                          el?.fieldName !== "rateofHire" &&
                          el?.fieldName !== "rateofTurnover"
                        ) {
                          displayValue =
                            index === 0
                              ? table?.maleTotal?.[el?.fieldName] ?? 0
                              : table?.femaleTotal?.[el?.fieldName] ?? 0;
                        }

                        return (
                          <TableCell
                            key={el?.fieldName}
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              paddingLeft:
                                el?.fieldName === "ageGroup"
                                  ? "0.8rem"
                                  : "1.7rem",
                            }}
                          >
                            {displayValue}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ))}
          <Box sx={{ mt: 1 }}>
            {errors[tableIndex] &&
              Object.entries(errors[tableIndex]).map(([rowIdx, rowErrors]) =>
                Object.entries(rowErrors).map(([field, errorMsg], idx) => (
                  <Typography
                    variant="body2"
                    color="error"
                    key={`${rowIdx}-${field}-${idx}`}
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 0",
                      color: "#d34040",
                      fontSize: "12px",
                      fontWeight: 600,
                    }}
                  >
                    {`Row ${parseInt(rowIdx) + 1}, ${field}: ${errorMsg}`}
                  </Typography>
                ))
              )}
          </Box>
        </Box>
      ))}

      {!hide && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            endIcon={<Add />}
            disabled={isAdded[inputData?.fieldName] || disabled}
            onClick={handleAddTable}
            sx={{
              color: "#1C486B",
              width: "11.2rem",
              borderColor: "#1C486B",
              textTransform: "none",
            }}
            variant="outlined"
          >
            Add New Region
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default DynamicRegionTable;
